









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "@/components/dialog/index.vue";
import { Button } from "mint-ui";

@Component<VBANNER>({
  props:['title'],
  components: {
    dialogComp,
    "mt-button": Button,
  },
})
export default class VBANNER extends Vue {
  public tipType:number = 0;/* 0是已参与过活动，1是未中奖 */
  public tipError:string = '';
  public giftTip:string = '';
  public name:string = '';
  public idNo:string = '';
  public winRecordId:string = '';
  public w:number = 0;
  public show() {
    (this.$refs.dialog as any).show();
    let timer = setInterval(()=>{
      this.w+=20
      if(this.w>=100){
        clearInterval(timer)
        this.w = 0;
        this.callback(this.close);
      }
    },400)
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public submit(){
      if(this.name == ''){
        (this as any).$dialog.alert({
            message:'姓名不能为空'
        })
        return
      }
      if(this.idNo == ''){
        (this as any).$dialog.alert({
            message:'身份证不能为空'
        })
        return
      }
      (this as any).$axios.get('/changma/rePrzie?name='+this.name+'&idCard='+this.idNo+'&winRecordId='+this.winRecordId,{
          name:this.name,
          idCard:this.idNo,
          winRecordId:this.winRecordId
      }).then((res:any)=>{
          if(res.code == 200){
              (this as any).$dialog.alert({
                  message:'提交成功'
              })
          }else{
              (this as any).$dialog.alert({
                  message:res.message
              })
          }
      })
  }
  public goUrl() {
    location.href =
      "https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong";
  }
  public callback(done:any){}
  public goLottery(){
    this.callback(()=>{});
    this.close();
  }
}
